import React, { useContext } from "react";

import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";
import { storageHelper } from "lib/helpers";
import { withErrorBoundary, withFeature } from "lib/hoc";
import OperatorOrderACSSetting from "./operator/features/acs/operatorOrderACSSetting";

const { userKey } = constant;
const { operator } = userKey;

const OrderACSSetting = () => {
  const { isLoading } = useContext(PrivateContext);
  const currentUserRole = storageHelper.get("userRole");
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorOrderACSSetting />;
    }
    return null;
  };
  const orderACSSetting = getComponent(currentUserRole);
  return orderACSSetting;
};

export default withFeature(withErrorBoundary(OrderACSSetting));
